import Marquee from "react-fast-marquee";

const items = [
  "Platform Supply Vessels",
  "Subsea Installation",
  "Heavy Lift",
  "Rigging & Slinging",
  "Load Chart Analysis",
  "Crane Maintenance",
  "Blind Lifts",
  "Tandem Lifts",
];

export const Ticker = () => (
  <div
    data-testid="ticker"
    className="border-y border-white/10 bg-[#0A111D] py-5"
  >
    <Marquee speed={38} gradient={false} autoFill>
      {items.map((item, i) => (
        <div key={i} className="flex items-center">
          <span className="font-mono text-sm tracking-[0.25em] uppercase text-[#94A3B8] mx-8">
            {item}
          </span>
          <span className="w-2 h-2 bg-accent rotate-45" />
        </div>
      ))}
    </Marquee>
  </div>
);
